export default __webpack_public_path__ + "static/media/code.c25a6ebb.png";